import cx from 'classnames'
import {Button} from 'components/system/Button'
import {useExploreMorePath} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'

type Props = {
  className?: string
}

export const EmptyCart = ({className}: Props) => {
  const exploreMorePath = useExploreMorePath()

  const onClick = useCallback(() => {
    window.location.href = exploreMorePath
  }, [exploreMorePath])

  return (
    <div className={cx('flex flex-col max-w-[426px] items-center', className)}>
      <div className="font-bold text-3xl">Empty? Let's explore!</div>
      <div className="mb-8 mt-2 text-center">
        You haven't added anything to your cart yet. Discover our exciting tours and activities!
      </div>
      <Button.Primary.Orange onClick={onClick}>Find Your Experience</Button.Primary.Orange>
    </div>
  )
}
